"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sample = void 0;
const Crop_1 = __importDefault(require("./Crop"));
const Client_1 = __importDefault(require("./Client"));
const Tabular_1 = require("./Tabular");
class Sample {
    constructor(obj) {
        this.id = obj.id || -1;
        this.code = obj.code || '';
        this.name = obj.name || '';
        this.reportVersion = obj.reportVersion || '';
        this.client = obj.client || new Client_1.default({});
        this.crop = obj.crop || new Crop_1.default({});
        this.parcel = obj.parcel || new Tabular_1.ParcelMinimal({});
        this.hasResults = obj.hasResults || false;
        this.metrics = obj.metrics || [];
    }
    get sampleName() {
        if (this.name.includes('')) {
            return this.name.split(' - ')[1];
        }
        return this.name;
    }
    get bioMetrics() {
        return this.metrics.filter(m => m).filter((m) => 'category' in m);
    }
    get phchMetrics() {
        return this.metrics.filter(m => m).filter((m) => 'visual' in m);
    }
    findDisplayedMetric(config) {
        if (config.isComparison) {
            if (config.dimension === 'bio') {
                if (config.vsMetric.higherIn !== '-') {
                    /*                     const metric = this.bioMetrics.find((m:BioMetric) => m.code_name === config.vsMetric.baseMetric.code_name)
                                        return metric */
                    if (config.isMainPanel) {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name);
                            return metric;
                        }
                    }
                    else {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name);
                            return metric;
                        }
                    }
                }
            }
            else {
                if (config.vsPhChMetric.higherIn !== '-') {
                    /*                     const metric = this.phchMetrics.find((m:PhChMetric) => m.code_name === config.vsPhChMetric.baseMetric.code_name && m.test_name === config.vsPhChMetric.baseMetric.test_name)
                                        return metric */
                    if (config.isMainPanel) {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name && m.test_name === config.vsMetric.winnerMetric.test_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name && m.test_name === config.vsMetric.defeatedMetric.test_name);
                            return metric;
                        }
                    }
                    else {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name && m.test_name === config.vsMetric.defeatedMetric.test_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name && m.test_name === config.vsMetric.winnerMetric.test_name);
                            return metric;
                        }
                    }
                }
            }
        }
        else {
            if (config.dimension === 'bio') {
                const metric = this.bioMetrics.find((m) => m.code_name === config.bioMetric.code_name);
                return metric;
            }
            else {
                const metric = this.phchMetrics.find((m) => m.code_name === config.phchMetric.code_name && m.test_name === config.phchMetric.test_name);
                return metric;
            }
        }
    }
    strokeColor(config) {
        if (config.baseState) {
            return '#85df4f';
        }
        else {
            if (config.dimension === 'phch') {
                return '#85df4f';
            }
            else {
                if (config.isNeedMaps) {
                    const activeNeedMap = this.needMaps.find((nm) => nm.category.slug === config.needMap.category.slug);
                    if (activeNeedMap)
                        return colorController.darkenColor(activeNeedMap.color, 0.9);
                    return '#000000';
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric)
                        return colorController.darkenColor(metric.color, 0.9);
                    return '#000000';
                }
            }
        }
    }
    fillColor(config) {
        if (config.baseState) {
            return '#85df4f20';
        }
        else {
            if (config.dimension === 'phch') {
                if (config.tiffUrl.length > 0) {
                    return '#ffffff00';
                }
                else {
                    return '#85df4f20';
                }
            }
            else {
                if (config.isNeedMaps) {
                    if (config.needMap.results.raster_url.length > 0) {
                        return '#ffffff00';
                    }
                    else {
                        const activeNeedMap = this.needMaps.find((nm) => nm === config.needMap);
                        if (activeNeedMap)
                            return activeNeedMap.transparency;
                        return '#00000050';
                    }
                }
                else {
                    if (config.tiffUrl) {
                        return '#ffffff00';
                    }
                    else {
                        const metric = this.findDisplayedMetric(config);
                        if (metric)
                            return metric.transparency;
                        return '#00000050';
                    }
                }
            }
        }
    }
    score(config) {
        if (config.isNeedMaps) {
            const activeNeedMap = this.needMaps.find((nm) => nm === config.needMap);
            if (activeNeedMap)
                return activeNeedMap.results.stats.mean;
            return -1;
        }
        else {
            if (config.isComparison) {
                if (config.dimension === 'bio') {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        if ('scoreBC' in metric) {
                            return metric.scoreBC.value;
                        }
                    }
                    return 0;
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        return metric.score;
                    }
                    return 0;
                }
            }
            else {
                if (config.dimension === 'bio') {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        if ('scoreBC' in metric) {
                            return metric.scoreBC.value;
                        }
                    }
                    return 0;
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        return metric.score;
                    }
                    return 0;
                }
            }
        }
    }
    get getAcreage() {
        if (this.parcel.geodata.length > 5) {
            const projections = { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
            const feature = new WKT().readFeature(this.polygon, projections);
            const geometry = feature.getGeometry();
            const area = olSphere.getArea(geometry);
            return (area / 10000).toFixed(2);
        }
    }
    get region() {
        // Need to calculate the region where the polygon is located
        // Optional: Replantear la idea
        return 'midwest';
    }
    get getCrop() {
        // Need to return the crop
        return this.crop.name;
    }
    // get meetsEBeCropConditions() {
    //     return this.eBeCropDiagnostic
    // }
    async downloadSampleReportPDF(gisFieldId) {
        const url = '/data/results/gis-field/pdf/' + gisFieldId;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
    async downloadFieldReportBySamplesPDF(projectId, gisAreaId, fieldName) {
        const body = new FormData();
        body.set('project_id', projectId);
        body.set('gis_area_id', gisAreaId);
        this.sampleCodes.forEach((c, index) => {
            body.set(`samples[${index}]`, c);
        });
        const polygon = this.polygon;
        // @ts-ignore
        body.set('polygon', polygon);
        // @ts-ignore
        body.set('field_name', fieldName);
        const fileName = `${fieldName}_${this.areaName}_report`;
        try {
            const response = await axios.post('/data/results/field/pdf', body, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                },
            });
            this.downloadPDF(response.data, fileName);
        }
        catch (error) {
            console.error('Error fetching or opening PDF:', error);
        }
    }
    downloadPDF(data, fileName) {
        const sanitizeFilename = (filename) => {
            filename = filename.replace(/[^\w\s]/gi, '_');
            return filename;
        };
        const newBlob = new Blob([data], { type: 'application/pdf' });
        const objUrl = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = objUrl;
        const sanitizedFilename = sanitizeFilename(fileName);
        link.download = `${sanitizedFilename}.pdf`;
        link.click();
        window.open(objUrl, '_blank');
        setTimeout(() => {
            window.URL.revokeObjectURL(objUrl);
        }, 250);
    }
    tabularize() {
        return new Tabular_1.SampleTabular({
            name: this.name,
            code: this.code,
            reportVersion: this.reportVersion,
            id: this.id,
            crop: this.crop,
            parcel: this.parcel,
            client: this.client,
            results: new Tabular_1.FarmReport({
                'bioMetrics': this.bioMetrics
            })
        });
    }
}
exports.Sample = Sample;
